<template>
  <!-- first section -->
  <div class="flex flex-col lg:flex-row  mt-24 lg:mt-12 lg:mt-32 px-6 w-full lg:space-x-4 " ref="observerElement">
    <!-- Text Section -->
    <transition name="fade-slide-left" mode="out-in" appear v-if="isVisible">
      <div class="lg:text-left  space-y-4 w-3/5">
        <p class="text-3xl lg:text-7xl font-futura text-navy">FUELING</p>
        <p class="text-3xl lg:text-7xl font-futura text-navy"> INNOVATION</p>


      </div>
    </transition>

    <!-- Description and Button Section -->
    <transition name="fade-slide-up" mode="out-in" appear v-if="isVisible">

      <div class="text-justify mt-4 lg:mt-0 space-y-8 w-full lg:w-10/12">
        <p class="text-base lg:text-2xl font-gramatika text-navy">
          Hanga Pitchfest brings the most influential experts together who help in selecting the best
          innovative ventures. These seasoned professionals provide invaluable insights and guidance,
          ensuring that the most promising startups receive the recognition and support they deserve.
        </p>

      </div>
    </transition>
  </div>

  <!-- 2025 judges -->

  <div class="ml-12 mt-32 flex space-x-2">
    <p class="font-gramatika text-lg">Judges</p>
    <hr class="w-[20px] border border-black mt-4 ">
    <p class="font-gramatika text-lg">2025</p>
  </div>


  <div class="relative overflow-x-auto flex  whitespace-nowrap scrollbar-hide mt-10 ml-0 -mb-44 lg:ml-12"
    ref="scrollContainer" style="height: 800px;" @touchstart="handleTouchStart" @touchmove="handleTouchMove">
    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/mutero.png" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 48, 0.05) 0%, rgba(1, 9, 48, 0.2) 50%, rgba(1, 9, 48, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              WILLIAM MUTERO
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-xl text-center"> Director Of CIDTA </p>
            <p class="text-white font-gramatika text-xl text-center"> CMU Africa</p>
          </div>
        </div>

      </div>
    </div>


    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/umurungi.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 48, 0.02) 0%, rgba(1, 9, 48, 0.15) 50%, rgba(1, 9, 48, 0.9) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              MICHELLE UMURUNGI
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-center text-xl"> Chief Investment Officer </p>
            <p class="text-white font-gramatika text-xl text-center"> RDB</p>
          </div>
        </div>

      </div>

    </div>


    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/mugabo.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 28, 0.02) 0%, rgba(1, 9, 28, 0.15) 30%, rgba(1, 9, 28, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              EMMANUEL MUGABO
            </p>
          </div>

          <div class="">

            <p class="text-white font-gramatika text-xl text-center ">Managing Director</p>
            <p class="text-white font-gramatika text-xl text-center">Inkomoko Rwanda</p>
          </div>
        </div>

      </div>


    </div>

    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/natalie.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 28, 0.02) 0%, rgba(1, 9, 28, 0.15) 30%, rgba(1, 9, 28, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              NATALIE JABANGWE

            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-xl text-center ">CEO</p>
            <p class="text-white font-gramatika text-xl text-center">Timbuktoo</p>
          </div>
        </div>

      </div>


    </div>

    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/alain.jpeg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 28, 0.02) 0%, rgba(1, 9, 28, 0.15) 30%, rgba(1, 9, 28, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              ALAIN KAJANGWE

            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-xl text-center ">CEO</p>
            <p class="text-white font-gramatika text-xl text-center">Wiredin</p>
          </div>
        </div>

      </div>


    </div>



  </div>


  <!-- 2024 judges -->

  <div class="ml-12 mt-32 flex space-x-2">
    <p class="font-gramatika text-lg">Judges</p>
    <hr class="w-[20px] border border-black mt-4 ">
    <p class="font-gramatika text-lg">2024</p>
  </div>


  <div class="relative overflow-x-auto flex  whitespace-nowrap scrollbar-hide mt-10 ml-0 -mb-44 lg:ml-12"
    ref="scrollContainer" style="height: 800px;" @touchstart="handleTouchStart" @touchmove="handleTouchMove">
    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/CEO Regis.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 48, 0.05) 0%, rgba(1, 9, 48, 0.2) 50%, rgba(1, 9, 48, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              REGIS RUGEMANSHURO
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-xl text-center"> CEO </p>
            <p class="text-white font-gramatika text-xl text-center"> RSSB</p>
          </div>
        </div>

      </div>
    </div>


    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/conard.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 48, 0.02) 0%, rgba(1, 9, 48, 0.15) 50%, rgba(1, 9, 48, 0.9) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              CONARD TUCKER
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-center text-xl"> Director </p>
            <p class="text-white font-gramatika text-xl text-center"> CMU-Africa</p>
          </div>
        </div>

      </div>

    </div>


    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/New Headshot.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 28, 0.02) 0%, rgba(1, 9, 28, 0.15) 30%, rgba(1, 9, 28, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              CHRISTELLE KWIZERA
            </p>
          </div>

          <div class="">

            <p class="text-white font-gramatika text-xl text-center"> Founder of Water Access Rwanda</p>
          </div>
        </div>

      </div>


    </div>

    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/PS Antoine.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 28, 0.02) 0%, rgba(1, 9, 28, 0.15) 30%, rgba(1, 9, 28, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              ANTOINE MARIE KAJANGWE

            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-xl text-center ">Permanent Secretary </p>
            <p class="text-white font-gramatika text-xl text-center">Ministry of Trade and Industry</p>
          </div>
        </div>

      </div>


    </div>



  </div>


  <div class="ml-12 mt-32 flex space-x-2">
    <p class="font-gramatika text-lg">Judges</p>
    <hr class="w-[20px] border border-black mt-4 ">
    <p class="font-gramatika text-lg">2023</p>
  </div>


  <div class="relative overflow-x-auto flex  whitespace-nowrap scrollbar-hide mt-10 ml-0 -mb-44 lg:ml-12"
    ref="scrollContainer" style="height: 800px;" @touchstart="handleTouchStart" @touchmove="handleTouchMove">
    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/alice.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 48, 0.05) 0%, rgba(1, 9, 48, 0.2) 50%, rgba(1, 9, 48, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              ALICE NKULIKIYINKA
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-xl text-center"> Country director </p>
            <p class="text-white font-gramatika text-xl text-center"> BPN Rwanda</p>
          </div>
        </div>

      </div>
    </div>


    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/conard.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 48, 0.02) 0%, rgba(1, 9, 48, 0.15) 50%, rgba(1, 9, 48, 0.9) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              CONARD TUCKER
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-center text-xl"> Director </p>
            <p class="text-white font-gramatika text-xl text-center"> CMU-Africa</p>
          </div>
        </div>

      </div>

    </div>


    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/eleni.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 28, 0.02) 0%, rgba(1, 9, 28, 0.15) 30%, rgba(1, 9, 28, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              ELENI GABRE-MADHIN
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-xl text-center ">Chief Innovation Officer</p>
            <p class="text-white font-gramatika text-xl text-center">UNDP Regional Bureau for Africa </p>
          </div>
        </div>

      </div>


    </div>

    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/nicole.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 28, 0.02) 0%, rgba(1, 9, 28, 0.15) 30%, rgba(1, 9, 28, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              NICOLE DAVIS
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-xl text-center ">World Bank Ltd</p>
            <p class="text-white font-gramatika text-xl text-center">Partner</p>
          </div>
        </div>

      </div>


    </div>



  </div>

  <!-- 2022 judges  -->
  <div class="ml-12 mt-32 flex space-x-2">
    <p class="font-gramatika text-lg">Judges</p>
    <hr class="w-[20px] border border-black mt-4 ">
    <p class="font-gramatika text-lg">2022</p>
  </div>

  <div class="relative overflow-x-auto flex  whitespace-nowrap scrollbar-hide mt-10 ml-0 -mb-44 lg:ml-12"
    ref="scrollContainer" style="height: 800px;" @touchstart="handleTouchStart" @touchmove="handleTouchMove">
    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/obina.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 48, 0.05) 0%, rgba(1, 9, 48, 0.2) 50%, rgba(1, 9, 48, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              OBINNA UKUANI
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-xl text-center">Chief Digital Officer </p>
            <p class="text-white font-gramatika text-xl text-center">Bank of Kigali Plc</p>
          </div>
        </div>

      </div>
    </div>


    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/hortense.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 48, 0.02) 0%, rgba(1, 9, 48, 0.15) 50%, rgba(1, 9, 48, 0.9) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              HORTENSE MUDENGE
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-center text-xl"> Chief Operations Officer </p>
            <p class="text-white font-gramatika text-xl text-center"> Rwanda Finance Ltd</p>
          </div>
        </div>

      </div>

    </div>


    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/eric.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 28, 0.02) 0%, rgba(1, 9, 28, 0.15) 30%, rgba(1, 9, 28, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              ERIC KACOU
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-xl text-center ">Ceo & Co-founder </p>
            <p class="text-white font-gramatika text-xl text-center">ESPartners </p>
          </div>
        </div>

      </div>


    </div>

    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/alice.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 48, 0.05) 0%, rgba(1, 9, 48, 0.2) 50%, rgba(1, 9, 48, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              ALICE NKULIKIYINKA
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-xl text-center"> Country director </p>
            <p class="text-white font-gramatika text-xl text-center"> BPN Rwanda</p>
          </div>
        </div>

      </div>
    </div>



  </div>

  <!-- 2021 judges -->
  <div class="ml-12 mt-32 flex space-x-2">
    <p class="font-gramatika text-lg">Judges</p>
    <hr class="w-[20px] border border-black mt-4 ">
    <p class="font-gramatika text-lg">2021</p>
  </div>


  <div class="relative overflow-x-auto flex  whitespace-nowrap scrollbar-hide mt-10 ml-0 -mb-44 lg:ml-12"
    ref="scrollContainer" style="height: 800px;" @touchstart="handleTouchStart" @touchmove="handleTouchMove">
    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/clarisse.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 48, 0.05) 0%, rgba(1, 9, 48, 0.2) 50%, rgba(1, 9, 48, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              CLARISSE IRIBAGIZA
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-xl text-center">Chief Executive Officer </p>
            <p class="text-white font-gramatika text-xl text-center">Hehe</p>
          </div>
        </div>
      </div>
    </div>


    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/sena.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 48, 0.02) 0%, rgba(1, 9, 48, 0.15) 50%, rgba(1, 9, 48, 0.9) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              PRO SENAIT FISSEHA
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-center text-xl"> Director of Global Programs</p>

            <p class="text-white font-gramatika text-xl text-center"> The Susan Thompson Buffett Foundation </p>
          </div>
        </div>

      </div>

    </div>


    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/Ron.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 28, 0.02) 0%, rgba(1, 9, 28, 0.15) 30%, rgba(1, 9, 28, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              RON FISHER
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-xl text-center "> Director, Strategic Product Growth </p>
            <p class="text-white font-gramatika text-xl text-center"> Mindbody </p>
          </div>
        </div>

      </div>


    </div>
    <div class="relative h-[582px] w-[400px] flex-shrink-0">
      <img src="../assets/eric.jpg" class="w-full h-full object-cover">
      <div class="absolute inset-0"
        style="background: linear-gradient(to bottom, rgba(1, 9, 28, 0.02) 0%, rgba(1, 9, 28, 0.15) 30%, rgba(1, 9, 28, 0.8) 100%);">
      </div>
      <div class="text-3xl font-futura text-white absolute inset-0 flex items-center justify-center">
        <div class="space-y-4 ">
          <div class=" mt-80">
            <p class="text-center">
              ERIC KACOU
            </p>
          </div>

          <div class="">
            <p class="text-white font-gramatika text-xl text-center ">Ceo & Co-founder </p>
            <p class="text-white font-gramatika text-xl text-center">ESPartners </p>
          </div>
        </div>

      </div>


    </div>



  </div>

  <!-- Quotes Carousel Section -->
  <div class="ml-4 md:ml-12 mt-12 md:mt-32">
    <div class="mt-8 md:mt-12 md:ml-16 overflow-hidden relative">
      <!-- Carousel Container -->
      <div ref="quotesWrapper" class="flex transition-transform duration-500 ease-in-out">
        <!-- Quote 1 -->
        <div class="w-full flex-shrink-0 px-4">
          <div class="flex flex-col md:flex-row md:space-x-32">
            <div class="md:w-1/3 p-6">
              <span class="font-futura text-tangerine text-5xl md:text-7xl">"</span>
              <p class="text-navy text-2xl md:text-2xl font-gramatika font-medium -mt-6 md:-mt-8">
                Like any other startup, we face challenges. But the exposure, network, and skills you gain through Hanga
                Pitchfest really prepare
                you for the next step—especially when it comes to starting your fundraising journey.
              </p>
              <div class="flex items-center mt-8">
                <hr class="w-8 md:w-12 border-2 border-navy mr-2">
                <p class="font-futura text-navy text-xl md:text-2xl">CEDRICK MUPENZI, SINC</p>
              </div>
            </div>
            <div class="md:w-1/2 flex items-center justify-center">
              <img src="../assets/sinc.png" class="max-h-[300px] md:max-h-[500px]">
            </div>
          </div>
        </div>

        <!-- Quote 2 -->
        <div class="w-full flex-shrink-0 px-4">
          <div class="flex flex-col md:flex-row md:space-x-32">
            <div class="md:w-1/3 p-6">
              <span class="font-futura text-tangerine text-5xl md:text-7xl">"</span>
              <p class="text-navy text-2xl md:text-2xl font-gramatika font-medium -mt-6 md:-mt-8">
                One of the main challenges we had was being able to scale our production. Especially after winning Hanga
                Pitchfest—this is
                just a door, a small door that's propelling us to actually do it quickly. We've always had quality, but
                now the focus is
                on producing at scale and making it affordable for the people who need it most.
              </p>
              <div class="flex items-center mt-8">
                <hr class="w-8 md:w-12 border-2 border-navy mr-2">
                <p class="font-futura text-navy text-xl md:text-2xl">CYNTIA , LOOPA</p>
              </div>
            </div>
            <div class="md:w-1/2 flex items-center justify-center">
              <img src="../assets/looopaa.png" class="max-h-[300px] md:max-h-[500px]">
            </div>
          </div>
        </div>

        <!-- Quote 3 -->
        <div class="w-full flex-shrink-0 px-4">
          <div class="flex flex-col md:flex-row md:space-x-32">
            <div class="md:w-1/3 p-6">
              <span class="font-futura text-tangerine text-5xl md:text-7xl">"</span>
              <p class="text-navy text-2xl md:text-2xl font-gramatika font-medium -mt-6 md:-mt-8">
                Winning Hanga Pitchfest has been a game-changer for Lifesten Health.It propelled us into the spotlight
                and opened doors to
                investors and esteemed clients, who were captivated by the impact that we could create together.
              </p>
              <div class="flex items-center mt-8">
                <hr class="w-8 md:w-12 border-2 border-navy mr-2">
                <p class="font-futura text-navy text-xl md:text-2xl">PEACE NDOLI, LIFESTEN HEALTH</p>
              </div>
            </div>
            <div class="md:w-1/2 flex items-center justify-center">
              <img src="../assets/lifestennn.png" class="max-h-[300px] md:max-h-[500px]">
            </div>
          </div>
        </div>

        <!-- Quote 4 -->
        <div class="w-full flex-shrink-0 px-4">
          <div class="flex flex-col md:flex-row">
            <div class="md:w-1/3 p-6">
              <span class="font-futura text-tangerine text-5xl md:text-7xl">"</span>
              <p class="text-navy text-2xl md:text-2xl font-gramatika font-medium -mt-6 md:-mt-8">
                After Hanga Pitch Fest, we no longer work in the same way we used to. We have been enrolled in different
                training and have since
                improved the quality and appearance of our products. We still make lighting and Bluetooth players but
                with high quality.
              </p>
              <div class="flex items-center mt-4">
                <hr class="w-8 md:w-12 border-2 border-navy mr-2">
                <p class="font-futura text-navy text-lg md:text-xl">DIANE CYUZUZO, AFRIDUINO</p>
              </div>
            </div>
            <div class="md:w-1/2 flex items-center justify-center">
              <img src="../assets/Group 41.svg" class="max-h-[300px] md:max-h-[500px]">
            </div>
          </div>
        </div>
      </div>

      <!-- Navigation Buttons -->
      <div class="flex justify-between mt-8 px-4 mt:mr-8">
        <button @click="prevQuote" class="border-2 rounded-full p-3 bg-white text-navy hover:bg-navy hover:text-white">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button @click="nextQuote"
          class="border-2 rounded-full p-3 bg-white text-navy hover:bg-navy hover:text-white mr-16">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  </div>

</template>


<script>
export default {
  name: 'JudgesPage',

  data() {
    return {
      currentQuote: 0,
      totalQuotes: 3,
      isVisible: false,
      isVisible2: false,
      startX: 0
    }
  },

  mounted() {
    this.updateCarousel();
    window.addEventListener('resize', this.updateCarousel);

    this.setupIntersectionObserver();

    const targetId = this.$route.hash.substring(1);
    if (targetId) {
      const target = document.getElementById(targetId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    this.initiativeAnimations();

    // Mouse drag handling for judge cards
    const scrollContainer = this.$refs.scrollContainer;
    if (scrollContainer) {
      scrollContainer.addEventListener('mousedown', this.handleMouseDown);
      scrollContainer.addEventListener('mousemove', this.handleMouseMove);
      scrollContainer.addEventListener('mouseup', this.handleMouseUp);
      scrollContainer.addEventListener('mouseleave', this.handleMouseUp);
    }
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.updateCarousel);

    const scrollContainer = this.$refs.scrollContainer;
    if (scrollContainer) {
      scrollContainer.removeEventListener('mousedown', this.handleMouseDown);
      scrollContainer.removeEventListener('mousemove', this.handleMouseMove);
      scrollContainer.removeEventListener('mouseup', this.handleMouseUp);
      scrollContainer.removeEventListener('mouseleave', this.handleMouseUp);
    }
  },

  methods: {
    handleMouseDown(e) {
      this.isDragging = true;
      this.startX = e.pageX - this.$refs.scrollContainer.offsetLeft;
      this.scrollLeft = this.$refs.scrollContainer.scrollLeft;
      this.$refs.scrollContainer.style.cursor = 'grabbing';
    },

    handleMouseMove(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.pageX - this.$refs.scrollContainer.offsetLeft;
      const walk = (x - this.startX) * 2;
      this.$refs.scrollContainer.scrollLeft = this.scrollLeft - walk;
    },

    handleMouseUp() {
      this.isDragging = false;
      this.$refs.scrollContainer.style.cursor = 'grab';
    },

    handleTouchStart(e) {
      this.startX = e.touches[0].clientX;
    },

    handleTouchMove(e) {
      const distance = this.startX - e.touches[0].clientX;
      this.$refs.scrollContainer.scrollLeft += distance;
      this.startX = e.touches[0].clientX;
    },

    nextQuote() {
      this.currentQuote = (this.currentQuote + 1) % this.totalQuotes;
      this.updateCarousel();
    },

    prevQuote() {
      this.currentQuote = (this.currentQuote - 1 + this.totalQuotes) % this.totalQuotes;
      this.updateCarousel();
    },

    updateCarousel() {
      const wrapper = this.$refs.quotesWrapper;
      if (wrapper) {
        wrapper.style.transform = `translateX(-${this.currentQuote * 100}%)`;
      }
    },

    initiativeAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
          }
        });
      });

      if (this.$refs.observerElement) {
        observer.observe(this.$refs.observerElement);
      }
    },

    setupIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('slide-up-visible');
            entry.target.classList.add('zoom-in-visible');
            entry.target.classList.add('fade-in-visible');
          }
        });
      });

      // Observe all elements with refs
      for (let key in this.$refs) {
        if (this.$refs[key]) {
          if (this.$refs[key].$el) {
            observer.observe(this.$refs[key].$el);
          } else {
            observer.observe(this.$refs[key]);
          }
        }
      }
    },

    missoutAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible1 = true;
          }
        });
      });

      if (this.$refs.observerElement1) {
        observer.observe(this.$refs.observerElement1);
      }
    }
  }
}
</script>

<style>
.scrollbar-hide {
  scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.scroll-container {
  cursor: grab;
  user-select: none;
}

.scroll-container:active {
  cursor: grabbing;
}


.fade-in {
  opacity: 0;
  transition: opacity 1.2s ease-in-out;
}

.fade-in-visible {
  opacity: 1;
}

.slide-up-enter-active,
.slide-left-enter-active,
.slide-right-enter-active {
  transition: all 0.7s ease-out;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(50px);
}

.slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
  /* Ensure Y-axis is reset to 0 */
}

.slide-left-enter-from {
  opacity: 0;
  transform: translateX(-50px);
}

.slide-left-enter-to {
  opacity: 1;
  transform: translateX(0);
  /* Reset X-axis */
}

.slide-right-enter-from {
  opacity: 0;
  transform: translateX(50px);
}

.slide-right-enter-to {
  opacity: 1;
  transform: translateX(0);
  /* Reset X-axis */
}

/* General Fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease-in-out;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
  {
  opacity: 0;
}

/* Fade and Slide Up */
.fade-slide-up-enter-active {
  transition: all 1s cubic-bezier(0.42, 0, 0.58, 1);
}

.fade-slide-up-enter-from {
  opacity: 0;
  transform: translateY(50px);
}

.fade-slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
}

/* Fade and Slide Left */
.fade-slide-left-enter-active {
  transition: all 1s cubic-bezier(0.42, 0, 0.58, 1);
  /* Even slower and more natural */
}

.fade-slide-left-enter-from {
  opacity: 0;
  transform: translateX(-80px);
}

.fade-slide-left-enter-to {
  opacity: 1;
  transform: translateX(0);
}

/* Fade and Slide Right */
.fade-slide-right-enter-active {
  transition: all 1s cubic-bezier(0.42, 0, 0.58, 1);
  /* Even slower and more natural */
}

.fade-slide-right-enter-from {
  opacity: 0;
  transform: translateX(80px);
}

.fade-slide-right-enter-to {
  opacity: 1;
  transform: translateX(0);
}

/* Zoom In */
.zoom-enter-active {
  transition: all 0.7s ease;
}

.zoom-enter-from {
  opacity: 0;
  transform: scale(0.9);
}

.zoom-enter-to {
  opacity: 1;
  transform: scale(1);
}

.fade-slide-up-enter-active,
.fade-slide-up-leave-active {
  transition: opacity 1.1s ease-in-out, transform 1.1s ease-in-out;
}

.fade-slide-up-enter-from {
  opacity: 0;
  transform: translateY(50px);
}

.fade-slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.fade-slide-up-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.fade-slide-up-leave-to {
  opacity: 0;
  transform: translateY(80px);
}
</style>